// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__20wl9","content":"RecentSearches_content__3mbqx"};